import { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { Container, Box, Tooltip } from "@mui/material";
import NetworkTable, { ColumnConfig, ColumnType, NetworkTableRow } from "../../components/InterfacesTable/NetworkTable/NetworkTable";
import "./InterfacesTab.css";
import FilterSearchAddBar from "../../components/FilterSearchAddBar/FilterSearchAddBar";
import AddEditInterfaceModal from "../../components/Modals/AddEditInterfaceModal";
import LabelValueDisplay from "../../components/LabelValue/LabelValueDisplay";
import { getAllInterfacesData, deleteInterfaceData, getPhysicalInterfacesData, addWanInterfaceData, updateWanInterfaceData, enableDisableInterfaceData, getFilteredNetworksData, deleteLanData, deleteWifiData, getDeviceLinkStatusData, getFilteredLanTrunkNetworksData } from '../../../../../actions/Users/authenticateOpenEdgeService';
import ToggleWithLabel from '../../components/ToggleWithLabel/ToggleWithLabel';
import { DELETE_INTERFACE, ADD_WAN_INTERFACE, UPDATE_WAN_INTERFACE, ENABLE_DISABLE_INTERFACE, DELETE_LAN, DELETE_WIFI, GET_ALL_INTERFACES } from '../../../../../actions/types';
import _ from "lodash";
import DeleteWANProfileModal from "../../components/Modals/DeleteProfileModal";
import MultipleSelectChip from "../../../../../components/MultipleSelectChip";
import CustomLoader from "../../../../../components/Loader/CustomLoader";
import TabsComponent from "../../../../../components/NewTabs";
import { isVersionLessThanEqual } from "../../../../../utils/util";
import { toast } from "react-toastify";
import HubIcon from '@mui/icons-material/Hub';
import WarningAmberIcon from '@mui/icons-material/Warning';
import { useConfigAutoRefresh } from "../../hooks/useConfigAutoRefresh";

const renderDisableTextSuffix = (rowData: any) => {
  const isWifiWAN = rowData?.interface_type === 'WIFI' && rowData?.mode !== 'ap';
  if (!isWifiWAN || rowData?.autoDisable !== true) return null;
  return (
    <Tooltip title="Auto disabled due to WiFi WAN being down">
      <WarningAmberIcon sx={{ color: "#FFA500", fontSize: 16, flexShrink: 0, cursor: "default" }} />
    </Tooltip>
  );
};

const InterfacesTab = (props) => {
  const { handleTabChange, getAllInterfacesData, getAllInterfaces, selectedRow, deleteInterfaceData, deleteInterface, getPhysicalInterfacesData, getPhysicalInterfaces, addWanInterfaceData, addWanInterface, updateWanInterfaceData, updateWanInterface, enableDisableInterfaceData, enableDisableInterface, getFilteredNetworksData, getFilteredNetworks, deleteWifiData, deleteLanData, deleteLan, deleteWifi,
    getAllInterfacesLoading, getPhysicalInterfacesLoading, getFilteredNetworksLoading, addWanInterfaceLoading, updateWanInterfaceLoading, deleteInterfaceLoading, enableDisableInterfaceLoading, deviceInfo, getDeviceLinkStatusData, getDeviceLinkStatus, refreshIconClicked, setRefreshIconClicked, getFilteredLanTrunkNetworksData, lANTrunkFilteredNetworks, deviceLinkStatusLoading, location, history, notifyConfigAction, notifyConfigActionComplete,
   } = props;

  const dispatch = useDispatch();
  const isHubSupported = !['T101', 'T103'].includes(selectedRow?.tierValue);
  const isRB100Device = selectedRow?.deviceId?.startsWith('RB');
  // Wi-Fi Band became editable on an existing interface starting with build v2.2.0.0;
  // on older builds it stays read-only on edit, as before.
  const isWifiBandEditable = !!selectedRow?.['current_EOS_version']
    && isVersionLessThanEqual('v2.2.0.0', selectedRow['current_EOS_version']);
  const [interfaces, setInterfaces] = useState<any>([]);
  const [hubTogglePendingRow, setHubTogglePendingRow] = useState<any>(null);
  const [physicalInterfaces, setPhysicalInterfaces] = useState<any>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filters, setFilters] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [formData, setFormData] = useState<any>({ ssid: '', alias: '' });
  const [isEditPopup, setIsEditPopup] = useState(false);
  const [vidError, setVidError] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [row, setRow] = useState<any>({});
  const [lanNetworks, setLanNetworks] = useState<any>([]);
  const [aliasError, setAliasError] = useState('');
  const [ssidError, setSsidError] = useState('');
  const [passwordError, setPasswordError] = useState("");
  const [interfaceTyp, setInterfaceTyp] = useState("");
  const [allowWANtypeChange, setAllowWANtypeChange] = useState(true);
  const [allowLANtypeChange, setAllowLANtypeChange] = useState(true);
  const [columns, setColumns] = useState<ColumnConfig[]>([
    {
      label: "",
      key: "active",
      type: ColumnType.sliderText,
      maxWidth: "41px",
    },
    {
      label: "Name",
      key: "alias_tmp",
      type: ColumnType.textWithImage,
      maxWidth: "218px",
      suffixKey: "hubRowData" as any,
      renderSuffix: renderDisableTextSuffix,
    },
    ...(isHubSupported ? [{
      label: "Hub Dropoff",
      key: "hubRowData" as any,
      type: ColumnType.text,
      maxWidth: "50px",
      renderCell: (rowData: any) => {
        if (!rowData) return null;
        const isWAN = rowData.interface_type === 'WAN';
        const isWifiWAN = rowData.interface_type === 'WIFI' && rowData.mode !== 'ap';
        if (!isWAN && !isWifiWAN) return null;
        return (
          <Tooltip title={rowData.hub_enabled ? 'Enabled' : 'Disabled'}>
            <HubIcon
              style={{
                fontSize: 16,
                color: '#244c84',
                opacity: rowData.hub_enabled ? 1 : 0.1,
                cursor: 'pointer',
                display: 'block',
              }}
              onClick={() => setHubTogglePendingRow(rowData)}
            />
          </Tooltip>
        );
      },
    }] : []) as ColumnConfig[],
    // {
    //   label: "VLAN Id",
    //   key: "vlanId",
    //   type: ColumnType.text,
    //   maxWidth: "63px",
    // },
    {
      label: "Physical Interface",
      key: "primary_interface",
      type: ColumnType.text,
      maxWidth: "63px",
    },
    {
      label: "Type",
      key: "interface_tmp",
      type: ColumnType.text,
      maxWidth: "89px",
    },
    {
      label: "Link Type",
      key: "link_type",
      type: ColumnType.text,
      maxWidth: "89px",
    },
    {
      label: "Assignment",
      key: "custom",
      type: ColumnType.listWithLabel,
      maxWidth: "242px",
    },
    {
      label: "Actions",
      key: "custom",
      type: ColumnType.actions,
      maxWidth: "68px",
      actions: (row: NetworkTableRow) => {
        const isPrimary = row.is_primary === true || row.is_primary === "1";
        const isLAN = row.interface_type === "LAN";
        return isPrimary || isLAN
          ? ["setting"]
          : ["setting", "delete"];
      }
    }
  ]);
  const [activeTab, setActiveTab] = useState('devices');

  const validatePassword = (value, mode) => {
    if (value === "") {
      setPasswordError("");
      return;
    }

    if (mode === "WAN WI-FI") {
      setPasswordError("");
    } else if (mode === "Access Point") {
      if (value.length < 8) {
        setPasswordError("Password must be at least 8 characters.");
      } else if (value.length > 32) {
        setPasswordError("Password cannot exceed 32 characters.");
      } else {
        setPasswordError("");
      }
    }
  };

const handleChange = (key: string) => (e: any, newValue?: any) => {
  // Support event, (event,newValue) and direct value calling conventions
  const value = typeof newValue !== 'undefined' && key === "access_networks"
    ? newValue
    : (e && e.target && typeof e.target.value !== 'undefined')
      ? e.target.value
      : e;

  if (key == "mode") {
    setFormData((prev) => ({
      ...prev,
      device: ''
    }));

    // Re-validate password when mode changes
    if (formData.password) {
      validatePassword(formData.password, value);
    }
  }

  if (key === "ssid") {
    if (value === "") {
      setSsidError("");
    } else if (!/^[a-zA-Z0-9\-_\. ]+$/.test(value)) {
      setSsidError("Only letters, numbers, -, _, ., spaces allowed");
    } else {
      setSsidError("");
    }
    setFormData((prev) => ({
      ...prev,
      ssid: value,
      alias: value,
    }));
    return;
  }

  if (key === "type") {
  const newType = value;

    // WAN → LAN conversion
    if (newType === "LAN") {
      const allNetworks = lanNetworks || [];

      setFormData((prev) => ({
        ...prev,
        type: "LAN",
        linkType: "LAN Trunk",

        // LAN Trunk → select ALL networks
        access_networks: allNetworks.map(n => n.network_alias),

        // clear access-only fields
        access_network: undefined,
        access_network_id: undefined,
        access_network_vid: undefined,

        networks: allNetworks
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        type: newType,
        linkType: '',
      }));
    }
    return;
  }


  if (key === "linkType") {
    const newType = value;

    // LAN Access → select FIRST network only
    if (newType === "LAN Access") {
      const firstNetwork = formData.networks?.[0];

      setFormData((prev) => ({
        ...prev,
        linkType: "LAN Access",
        access_network: firstNetwork?.network_alias,
        access_network_id: firstNetwork?.id,
        access_network_vid: firstNetwork?.vlan_id,
        access_networks: undefined
      }));
    }

    // LAN Trunk → select ALL networks
    else if (newType === "LAN Trunk") {
      setFormData((prev) => ({
        ...prev,
        linkType: "LAN Trunk",
        access_networks: prev.networks?.map(n => n.network_alias),
        access_network: undefined
      }));
    }
    else {
       setFormData((prev) => ({
        ...prev,
        linkType: newType,

      }));
    }

    return;
  }


  if (key === "access_networks") {
    const newType = value;
    setFormData((prev) => ({
      ...prev,
      access_networks: newType,
    }));
    return;
  }

  // if (key === "network") {
  //   const selectedNetwork = lanNetworks.find(n => n.network_alias === value);
  //   const isCaptive = selectedNetwork?.isCaptive;

  //   setFormData((prev) => ({
  //     ...prev,
  //     network: value,
  //     // security: isCaptive ? "Open" : "",     
  //     // password: isCaptive ? "" : prev.password, 
  //     // forceSecurityOpen: isCaptive || false,
  //   }));
  //   return;
  // }

  if (key === "security") {
    if (value === "Open") {
      setFormData((prev) => ({
        ...prev,
        security: value,
        password: "", 
      }));
    } else {
      setFormData((prev) => ({ ...prev, security: value }));
    }
    return;
  }

  setFormData((prev) => ({ ...prev, [key]: value }));

  if (key === "name") {
    if (value === "") {
      setAliasError("");
    } else if (!/^[a-zA-Z]/.test(value)) {
      setAliasError("Must start with a letter.");
    } else if (!/^[a-zA-Z0-9_ ]*$/.test(value)) {
      setAliasError("Only letters, numbers, spaces, and underscore allowed.");
    } else {
      setAliasError("");
    }
  }

  // VLAN ID validation
  if (key === "vid") {
    const numberValue = Number(value);
    let error = "";
    if (value === "") {
      setVidError("");
      return;
    }
    if (numberValue < 1 || numberValue > 4095) {
      error = "VID must be between 1 and 4095.";
    } else {
      const isDuplicate = interfaces?.some(
        (iface) => iface?.vlanId?.toString() === value
      );
      if (isDuplicate) {
        error = "This VLAN ID already exist.";
      }
    }
    setVidError(error);
  }


  if (key === "password") {
    validatePassword(value, formData.mode);
  }
};
  // Skip the very first firing (tab mount) of the interfaces-status call:
  // InventoryPopup's centralized effect already refreshes it once when this
  // tab opens, so this only needs to react to an actual manual refresh click.
  const skipFirstLinkStatusFetchRef = useRef(true);
  useEffect(() => {
    if(refreshIconClicked) {
      getAllInterfacesData(selectedRow['deviceId'],interfaceTyp, selectedRow['current_EOS_version']);
      if (skipFirstLinkStatusFetchRef.current) {
        skipFirstLinkStatusFetchRef.current = false;
      } else {
        getDeviceLinkStatusData(selectedRow['k4Id'], selectedRow['deviceId']);
      }
    }
  }, [refreshIconClicked])

  // Same calls the manual refresh button triggers, but on a 30s idle baseline
  // (immediate on mount/tab switch too), sped up to 2s during an in-flight
  // config change via startAction()/stopAction() below. Interfaces status
  // itself is refreshed centrally (InventoryPopup), not duplicated here.
  const interfacesAutoRefresh = useConfigAutoRefresh({
    fetchFns: [
      (silent) => getAllInterfacesData(selectedRow['deviceId'], interfaceTyp, selectedRow['current_EOS_version'], silent),
    ],
    enabled: !!selectedRow?.deviceId,
  });

  useEffect(() => {
    if (!_.isEmpty(getAllInterfaces)) {
      const data = getAllInterfaces && getAllInterfaces.hasOwnProperty('status') && getAllInterfaces.status == true ? getAllInterfaces?.interfaces : [];
      const statusList = getDeviceLinkStatus && getDeviceLinkStatus.hasOwnProperty('result') ? getDeviceLinkStatus?.result?.data : [];
      // success === false is a real, backend-confirmed "couldn't sync with the
      // device" response (not a swallowed client-side network error, which is
      // already filtered out before this state is ever set) - treat every
      // interface as down rather than unknown/grey.
      const linkStatusSyncFailed = getDeviceLinkStatus?.success === false;
      const updated = data?.map((item) => {
        const matched = statusList?.find((s) => s.alias === item.alias);
        let color;
        let tempInterface;
        let ip_address_vid;
        let dns_server;
        let gateway;
        if (matched) {
          color = matched.link_up ? 'GREEN' : 'RED'
          tempInterface = matched?.tmp_interface_type ? matched?.tmp_interface_type : ""
          ip_address_vid = matched?.ip_address_vid ? matched?.ip_address_vid : ""
          dns_server = matched?.dns_server ? matched?.dns_server : ""
          gateway = matched?.gateway ? matched?.gateway : ""
        }
        else { color = linkStatusSyncFailed ? 'RED' : 'GREY' }
        let updatedItem = {
          ...item,
          color,
          tempInterface,
          ip_address_vid,
          dns_server,
          gateway,
          hub_enabled: item['hub_enabled'] === true || item['hub_enabled'] === 'true',
        };
        if (Array.isArray(updatedItem.wan_profiles) && (tempInterface == "WAN" ||tempInterface == "WIFI WAN")) {
          updatedItem = {
            ...updatedItem,
            wan_profiles: [
              {
                id: 0,
                profileName: ip_address_vid
              }
            ]
          };
        }
        return { ...updatedItem, hubRowData: updatedItem };
      });
      setInterfaces(updated);
      setAllowWANtypeChange(
        updated.filter(
          (item) =>
            item?.is_primary &&
            item?.interface_type === "WAN" &&
            item?.device !== "wwan0"
        ).length > 1
      );      
      setAllowLANtypeChange(
        updated.filter(
          (item) =>
            item?.is_primary &&
            item?.interface_type === "LAN"
        ).length > 1
      );  
      // setRefreshIconClicked(false);
    }
  }, [getAllInterfaces, getDeviceLinkStatus])

  const handleToggle = (headerKey: string, value: boolean, row: NetworkTableRow) => {
    setInterfaces((prev) =>
      prev.map((item) =>
        item.id === row.id ? { ...item, [headerKey]: value } : item
      )
    );
    const payload = {
      "DID": selectedRow['deviceId'],
      "id": row['id'],
      "active": value
    }
    setRow(row);
    interfacesAutoRefresh.startAction();
    notifyConfigAction?.();
    enableDisableInterfaceData(payload, row.interface_type == 'WIFI' ? 'enableDisableWIFIInterface' : 'enableDisableInterface');
  };

  const handleHyperlinkClick = (headerKey: string, value: string, row?: NetworkTableRow) => {
    console.log("Hyperlink Clicked =>", { headerKey, value });

    if (headerKey === "custom") {
      try {
        const parsed = JSON.parse(value);
        const aliases = parsed.map((val: string) => val.split("(")[0].trim());
        const interfaceType = row?.interface_type;

        if(row?.interface_tmp === 'WiFi WAN') {
          handleTabChange("SD-WAN", 1, '', "ip_configuration");
        } else if (interfaceType === "LAN") {
          sessionStorage.setItem("lanTabFilters", JSON.stringify(aliases));
          (window as any).__lanTabFilterAliases = aliases;
          handleTabChange("LAN", 2);
        } else if (interfaceType === "WAN") {
          handleTabChange("SD-WAN", 1, '', "ip_configuration");
        } else {
          const clickedProfile = aliases[0];
          const allProfiles = aliases.map(a => a.trim());
          allProfiles.forEach(profile => {
            handleTabChange("LAN", 2);
          });
        }

      } catch (e) {
        console.error("Failed to parse hyperlink value", e);
      }
    }
  };

  const handleActionClick = (
    type: "setting" | "refresh" | "delete" | "portal" | "edit",
    headerKey: string,
    row: NetworkTableRow
  ) => {
    console.log(`Action "${type}" clicked on ${headerKey}`, row);
    switch (type) {
      case "delete":
        setIsDeleteModalOpen(true);
        setRow(row);
        break;
      case "setting":
        setIsModalOpen(true);
        setIsEditPopup(true);

        switch (row['interface_type']) {
          case 'WAN':
            setFormData({
              type: row['interface_type'],
              name: row['alias'],
              physicalInterface: row['primary_interface'],
              linkType: row['link_type'],
              vid: row['vlanId'],
              id: row['id'],
              is_primary: row['is_primary'],
              wan_profiles: [],
              proto: row['proto'],
              hub_enabled: row['hub_enabled'] ?? false,
            });
            break;

          case 'LAN':
            setFormData({
              type: row['interface_type'],
              name: row['alias'],
              physicalInterface: row['primary_interface'],
              network: row['network_alias'],
              linkType: row['link_type'],
              vid: row['vlanId'],
              id: row['id'],
              is_primary: row['is_primary'],
              networks: row['networks'],
              access_network: row['access_name'],
              access_network_id: row['access_rec_id'],
              access_network_vid: row['access_vlan_id'],
              // Prefill multi-select when editing a LAN Trunk
              access_networks: row['link_type'] === 'LAN Trunk' ? (row['networks']?.map((n: any) => n.network_alias) || []) : undefined,
            });
            break;

          case 'WIFI':
            const isCaptive = lanNetworks.find(n => n.network_alias === row['network'])?.isCaptive;

            setFormData({
              type: row['interface_type'],
              device: row['device'] === 'radio1' ? 'WIFI_5' : 'WIFI_2.4',
              ssid: row['ssid'],
              password: row['key'],
              mode: row['mode'] == 'ap' ? 'Access Point' : 'WAN WI-FI',
              physicalInterface: row['primary_interface'],
              alias: row['alias'],
              id: row['id'],
              network: row['network'],
              is_primary: row['is_primary'],
              wan_profiles: row['wan_profiles'],
              security: (row['security'] == 'Open' || row['security'] == '') ? 'Open' : 'WPA2/WPA3',
              hub_enabled: row['hub_enabled'] ?? false,
              // forceSecurityOpen: isCaptive || false,
            });
            break;


          default:
            // Handle unknown type (optional)
            break;
        }
        break;
      default:
        console.warn(`Unhandled action type: ${type}`);
    }
  };

  useEffect(() => {
    if (!_.isEmpty(deleteInterface) || !_.isEmpty(deleteLan) || !_.isEmpty(deleteWifi) || !_.isEmpty(addWanInterface) || !_.isEmpty(updateWanInterface) || !_.isEmpty(enableDisableInterface)) {
      interfacesAutoRefresh.stopAction();
      notifyConfigActionComplete?.();
    }
    if (!_.isEmpty(deleteInterface) && deleteInterface?.status == true) {
      getAllInterfacesData(selectedRow['deviceId'],interfaceTyp, selectedRow['current_EOS_version']);
      dispatch({ type: DELETE_INTERFACE, payload: {} })
      setIsDeleteModalOpen(false);
    }
    if (!_.isEmpty(deleteLan) && deleteLan?.status == true) {
      getAllInterfacesData(selectedRow['deviceId'],interfaceTyp, selectedRow['current_EOS_version']);
      dispatch({ type: DELETE_LAN, payload: {} })
      setIsDeleteModalOpen(false);
    }
    if (!_.isEmpty(deleteWifi) && deleteWifi?.status == true) {
      getAllInterfacesData(selectedRow['deviceId'],interfaceTyp, selectedRow['current_EOS_version']);
      dispatch({ type: DELETE_WIFI, payload: {} })
      setIsDeleteModalOpen(false);
    }
    if (!_.isEmpty(addWanInterface) && addWanInterface?.status == true) {
      getAllInterfacesData(selectedRow['deviceId'], interfaceTyp, selectedRow['current_EOS_version']);
      dispatch({ type: ADD_WAN_INTERFACE, payload: {} });
      setIsModalOpen(false);
      setFormData({});
    }
    if (!_.isEmpty(updateWanInterface) && updateWanInterface?.status == true) {
      getAllInterfacesData(selectedRow['deviceId'], interfaceTyp, selectedRow['current_EOS_version']);
      dispatch({ type: UPDATE_WAN_INTERFACE, payload: {} })
      setIsEditPopup(false);
      setIsModalOpen(false);
      setFormData({});
    }
    if (!_.isEmpty(getFilteredNetworks)) {
      const data = getFilteredNetworks && getFilteredNetworks.hasOwnProperty('status') && getFilteredNetworks.status ? getFilteredNetworks.access_networks : [];
      setLanNetworks(data);
    }

    if (_.isEmpty(enableDisableInterface)) return;
    if (enableDisableInterface.status === true) {
      getAllInterfacesData(selectedRow.deviceId, interfaceTyp, selectedRow['current_EOS_version']);
      dispatch({ type: ENABLE_DISABLE_INTERFACE, payload: {} });
    } else {
      if(enableDisableInterface?.msg){
        toast.error(enableDisableInterface?.msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        })
      }
      setInterfaces((prev) =>
        prev.map((item) =>
          item.id === row.id ? { ...item, active: row.active } : item
        )
      );
      dispatch({ type: ENABLE_DISABLE_INTERFACE, payload: {} });
    }
  }, [deleteInterface, deleteLan, deleteWifi, addWanInterface, updateWanInterface, enableDisableInterface, getFilteredNetworks])

  useEffect(() => {
    console.log('deviceInfo',deviceInfo)
    if (deviceInfo === 'ap') {
      const updatedColumns = columns.filter(col => col.label !== 'Actions');
      setColumns(updatedColumns);
    }
  }, [deviceInfo])


  useEffect(() => {
    getPhysicalInterfacesData(selectedRow['deviceId']);
  }, []);

  useEffect(() => {
    if (isModalOpen) {
      getFilteredNetworksData(selectedRow['deviceId']);
    }
  }, [isModalOpen])

  useEffect(() => {
    if (!_.isEmpty(getPhysicalInterfaces)) {
      const data = getPhysicalInterfaces && getPhysicalInterfaces.hasOwnProperty('status') && getPhysicalInterfaces.status ? getPhysicalInterfaces.interfaces : [];
      setPhysicalInterfaces(data);
    }
  }, [getPhysicalInterfaces])

  const handleAddInterface = () => {
    interfacesAutoRefresh.startAction();
    notifyConfigAction?.();
    const { type } = formData;
    const DID = selectedRow?.deviceId;

  let payload: any = { data: {} };

    // Find the matching device from physical interfaces list
    const selectedDeviceObj = physicalInterfaces.find(item => item.alias === formData.physicalInterface);
    const selectedNetwork = formData.networks?.find(item => item.network_alias == formData.access_network);

    if (type === 'WAN') {
      payload.data = {
        device: selectedDeviceObj?.device,
        interface_type: type,
        alias: formData.name,
        link_type: formData.linkType,
        proto: isEditPopup ? formData?.proto : true,
        is_primary: !isEditPopup ? '0' : formData.is_primary ? '1' : '0',
        primary_interface: selectedDeviceObj?.primary_interface,
        vlanId: !isEditPopup ? formData.vid : undefined,
        swVersion: selectedRow['current_EOS_version'],
        DID,
        ...(isEditPopup && { id: formData?.id }),
        ...(isHubSupported && { hub_enabled: !!formData?.hub_enabled })
      };
      if (isEditPopup) {
        updateWanInterfaceData(payload, 'updateWANInterface');
      } else {
        addWanInterfaceData(payload, 'addWANInterface');
      }
    }

    else if (type === 'LAN' && isEditPopup) {
      payload.data = {
        device: selectedDeviceObj?.device,
        interface_type: type,
        alias: formData.name,
        link_type: formData.linkType,
        is_primary: !isEditPopup ? '0' : formData.is_primary ? '1' : '0',
        primary_interface: selectedDeviceObj?.primary_interface,
        DID,
        id: formData?.id,
        access_vlan_id: formData.linkType == 'LAN Access' ? selectedNetwork.vlan_id : undefined,
        access_rec_id: formData.linkType == 'LAN Access' ? selectedNetwork.id : undefined,
        access_name: formData.linkType == 'LAN Access' ? selectedNetwork.network_alias : undefined,
        swVersion: selectedRow['current_EOS_version'],
      };
      // If LAN Trunk, map selected access network aliases to their ids and include in payload
      if (formData.linkType === 'LAN Trunk' && Array.isArray(formData?.access_networks) 
        && !isVersionLessThanEqual(selectedRow['current_EOS_version'], 'v1.1.0.754')
      ) {
        const accessNetworks = (formData.access_networks || []).map((alias) => {
          const found = formData.networks?.find((n) => n.network_alias === alias);
          return found
            ? { vlanId: found.vlan_id, name: found.network_alias }
            : undefined;
        })
        if (payload?.data && accessNetworks.length > 0) {
          payload.data.trunk_port_networks = accessNetworks;
        }
      }
      updateWanInterfaceData(payload, 'updateWANInterface');
    }

    else if (type === 'WIFI') {
      const selectedNetwork = lanNetworks.find(network => network.network_alias === formData.network);

      payload.data = {
        action: isEditPopup ? 'update' : 'create',
        DID,
        device: formData.device === 'WIFI_5' ? 'radio1' : 'radio0',
        ssid: formData.ssid,
        key: formData?.security == 'WPA2/WPA3' ? formData.password : '',
        mode: formData.mode == 'Access Point' ? 'ap' : 'sta',
        is_primary: !isEditPopup ? '0' : formData.is_primary ? '1' : '0',
        primary_interface: formData.device,
        alias: formData.alias,
        network: formData?.mode == 'Access Point' ? formData.network : undefined,
        network_id: formData?.mode == 'Access Point' ? selectedNetwork.id : undefined,
        network_vlan_id: formData?.mode == 'Access Point' ? selectedNetwork?.vlan_id : undefined,
        ...(isEditPopup && { id: formData?.id }),
        ...(isHubSupported && formData?.mode !== 'Access Point' && { hub_enabled: !!formData?.hub_enabled }),
      };
      isEditPopup ? updateWanInterfaceData(payload, 'processWifiInterface') : addWanInterfaceData(payload, 'processWifiInterface');
    }
  };

  const handleClosePopup = () => {
    setIsModalOpen(false);
    setIsEditPopup(false);
    setFormData({});
    setSsidError('');
    dispatch({ type: ADD_WAN_INTERFACE, payload: {} });
    dispatch({ type: UPDATE_WAN_INTERFACE, payload: {} });
  }

  const handleHubToggleConfirm = () => {
    if (!hubTogglePendingRow) return;
    interfacesAutoRefresh.startAction();
    notifyConfigAction?.();
    const targetRow = hubTogglePendingRow;
    const newHubEnabled = !targetRow.hub_enabled;

    const payload: any = { data: {} };

    if (targetRow.interface_type === 'WAN') {
      payload.data = {
        device: targetRow.device,
        interface_type: targetRow.interface_type,
        alias: targetRow.alias,
        link_type: targetRow.link_type,
        proto: targetRow.proto,
        is_primary: targetRow.is_primary ? '1' : '0',
        primary_interface: targetRow.primary_interface,
        swVersion: selectedRow['current_EOS_version'],
        DID: selectedRow['deviceId'],
        id: targetRow.id,
        hub_enabled: newHubEnabled,
      };
      updateWanInterfaceData(payload, 'updateWANInterface');
    } else if (targetRow.interface_type === 'WIFI') {
      payload.data = {
        action: 'update',
        DID: selectedRow['deviceId'],
        device: targetRow.device,
        ssid: targetRow.ssid,
        key: targetRow.key,
        mode: targetRow.mode,
        is_primary: targetRow.is_primary ? '1' : '0',
        primary_interface: targetRow.primary_interface,
        alias: targetRow.alias,
        id: targetRow.id,
        hub_enabled: newHubEnabled,
      };
      updateWanInterfaceData(payload, 'processWifiInterface');
    }

    setHubTogglePendingRow(null);
  };

  const isFormValid = (): boolean => {
    if (!formData) return false;
    const { type, name, physicalInterface, device, vid, ssid, password, mode, network, linkType, security, alias, access_network } = formData;
    if (!type) return false;
    if (type === "WAN") {
      if (!name || aliasError) return false;
    } else if (type === "WIFI") {
      if (!alias || ssidError) return false;
    }
    if (type !== "WIFI") {
      if (!isEditPopup) {
        if (vid === undefined || vid === "" || vidError) return false;
        const vidNum = Number(vid);
        if (isNaN(vidNum) || vidNum < 1 || vidNum > 4095) return false;
      }
      if (type === "WAN") {
        if (!physicalInterface || !linkType) return false;
      }
    }
    if (type === "WIFI") {
      if (!device || !ssid || !mode || !security) return false;
      if (security === "WPA2/WPA3" && (!password || passwordError)) return false;

      if (mode === "Access Point" && !network) return false;
    }
    if (type === "LAN" && linkType === "LAN Access" && !access_network) {
      return false;
    }
    // Require at least one access network for LAN Trunk
    if (type === "LAN" && linkType === "LAN Trunk" && (!formData?.access_networks || formData?.access_networks.length === 0)) {
      return false;
    }
    return true;
  };

  const handleInterfaceTypeData = (type)=> {
    const interface_type = type;
    setInterfaceTyp(type)
    setInterfaces([]);
    getAllInterfacesData(selectedRow['deviceId'], interface_type, selectedRow['current_EOS_version']);
  }

  useEffect(() => {
    if (isEditPopup) {
      getFilteredLanTrunkNetworksData(selectedRow['deviceId'], formData?.linkType);
    }
  }, [isEditPopup, formData?.linkType]);

  useEffect(() => {
    if (!_.isEmpty(lANTrunkFilteredNetworks)) {
      const data = lANTrunkFilteredNetworks && lANTrunkFilteredNetworks.hasOwnProperty('status') && lANTrunkFilteredNetworks.status ? lANTrunkFilteredNetworks.access_networks : [];
      setFormData({
        ...formData, 
        networks: [
          ...(formData['access_network'] && !data.some(n => n.network_alias === formData['access_network'])
            ? [{
              id: formData['access_network_id'],
              network_alias: formData['access_network'],
              vlan_id: formData['access_network_vid'],
            }]
            : []),
          ...(data || []),
        ]
      })
    }
  }, [lANTrunkFilteredNetworks])

  const tabs = [
    { tabName: 'Devices', tabValue: 'devices', pathName: '/inventory' }
  ];

  const doNavigateTab = (pathname, tabName) => {
    setActiveTab(tabName);
  }

  return (<div className={`internalPadding${isRB100Device ? ' hide-wifi-filter' : ''}`}>
    <TabsComponent tabs={tabs} handleChangeTab={doNavigateTab} activeTab={activeTab} isSubTabs={true} removemarginTop={true} />
    <Container maxWidth="xl" className="app-container">
      {activeTab == 'devices' && <Box my={0}>
        <NetworkTable
          data={interfaces}
          columns={columns}
          onToggle={handleToggle}
          onHyperlinkClick={handleHyperlinkClick}
          onActionClick={handleActionClick}
          showFilterBar
          showInterfaceIcons
          addButtonLabel="Add Interface"
          onAddClick={() => setIsModalOpen(true)}
          onInterfaceTypeClick={(type) => handleInterfaceTypeData(type)}
          deviceInfo={deviceInfo}
        />
      </Box>}
      {getAllInterfacesLoading || getPhysicalInterfacesLoading || getFilteredNetworksLoading || addWanInterfaceLoading || updateWanInterfaceLoading || deleteInterfaceLoading || enableDisableInterfaceLoading || deviceLinkStatusLoading ? (
        <CustomLoader
          showLoader={true}
          loadingText={"Please wait..."}
        />
      ) : null}
    </Container>

    <AddEditInterfaceModal
      open={isModalOpen}
      onClose={handleClosePopup}
      onSave={handleAddInterface}
      saveText={isEditPopup ? 'Update' : 'Add'}
      disableSave={!isFormValid()}
      title={isEditPopup ? 'Edit Interface' : 'Add Interface'}
      layout={[
        {
          columns: formData?.type === "WIFI"
            ?
            [
              {
                component: (
                  <LabelValueDisplay
                    label="SSID"
                    isInput
                    value={formData?.ssid}
                    onChange={handleChange("ssid")}
                    placeholder="Enter SSID"
                    error={ssidError}
                  />
                ),
                gridSize: 6,
              },
              {
                component: (
                  <LabelValueDisplay
                    label="Alias"
                    isInput
                    value={formData?.alias}
                    onChange={handleChange("alias")}
                    placeholder="Enter Alias"
                    disabled = {formData?.mode === "Access Point"}
                  />
                ),
                gridSize: 6,
              },
            ]
            :
            [
              {
                component: (
                  <LabelValueDisplay
                    label="Alias"
                    isInput
                    value={formData?.name}
                    onChange={handleChange("name")}
                    placeholder="Enter name"
                    error={aliasError}
                    disabled={isEditPopup && formData?.linkType == "LAN Access" && formData?.networks?.length > 0}
                  />
                ),
                gridSize: formData?.type === "WAN" ? 9 : 12,
              },
              {
                component: formData?.type == 'WAN' ? (
                  <LabelValueDisplay
                    type="number"
                    label="VLAN ID"
                    isInput
                    value={formData?.vid}
                    onChange={handleChange("vid")}
                    placeholder="Enter VLAN ID"
                    error={vidError}
                    disabled={isEditPopup}
                  />
                ) : null,
                gridSize: 3,
              },
            ]
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Interface Type"
                  isDropdown
                  value={formData?.type}
                  dropdownOptions={isEditPopup ? ["WAN", "LAN"] : (isRB100Device ? ["WAN"] : ["WAN", "WIFI"])}
                  onChange={handleChange("type")}
                  placeholder="Select type"
                  disabled={
                    isEditPopup && (
                      formData?.type === "WIFI" ||
                      (formData?.type === "LAN" && 
                        (!formData?.is_primary || !allowLANtypeChange)) ||
                      (formData?.type === "WAN" && (
                        !formData?.is_primary || !allowWANtypeChange
                      ))
                    )
                  }
                />
              ),
              gridSize: formData?.type === 'WIFI' ? 6 : 4,
            },
            {
              component:
                formData?.type === 'WIFI' ? (
                  <LabelValueDisplay
                    label="Mode"
                    isDropdown
                    value={formData?.mode}
                    dropdownOptions={["WAN WI-FI", "Access Point"]}
                    onChange={handleChange("mode")}
                    placeholder="Select Mode"
                    disabled={isEditPopup}
                  />
                ) : (
                  <LabelValueDisplay
                    label="Interface Name"
                    isDropdown
                    value={formData?.physicalInterface}
                    dropdownOptions={physicalInterfaces?.map((el) => el.alias)}
                    onChange={handleChange("physicalInterface")}
                    placeholder="Select interface"
                    disabled={isEditPopup}
                  />
                ),
              gridSize: formData?.type === 'WIFI' ? 6 : 4,
            },
            ...(formData?.type !== 'WIFI'
              ? [
                {
                  component: (
                    <LabelValueDisplay
                      label={formData?.type === "LAN" ? "LAN Type" : "WAN Type"}
                      isDropdown
                      value={formData?.linkType}
                      dropdownOptions={
                        formData?.type === "LAN"
                          ? ["LAN Trunk", "LAN Access"]
                          : [
                            "Cellular",
                            "Ethernet",
                            "L-Band",
                            "OneWeb",
                            "Starlink",
                            "Starlink Residential",
                            "VSAT",
                            "VSAT-HighSpeed",
                            "VSAT-Ka",
                            "VSAT-Ku",
                            "VSAT-Unlimited",
                            "VSAT-VOIP"
                          ]
                      }
                      onChange={handleChange("linkType")}
                      placeholder={`Select ${formData?.type === 'LAN' ? 'LAN' : 'WAN'} type`}
                    />
                  ),
                  gridSize: 4,
                },
              ]
              : []),
          ]
        },
        ...(formData?.type === "WAN" && isHubSupported
          ? [
            {
              columns: [
                {
                  component: (
                    <ToggleWithLabel
                      label="Hub Dropoff"
                      checked={!!formData?.hub_enabled}
                      onChange={(val) => setFormData((prev) => ({ ...prev, hub_enabled: val }))}
                    />
                  ),
                  gridSize: 12,
                },
              ],
            },
          ]
          : []),
        ...(formData?.type === "LAN" && formData?.linkType == 'LAN Access'
          ? [
            {
              columns: [
                {
                  component: (
                    <></>
                  ),
                  gridSize: 8,
                },
                {
                  component: (
                    <LabelValueDisplay
                      label="Access Network"
                      isDropdown
                      dropdownOptions={formData?.networks?.map(network => network.network_alias)}
                      value={formData?.access_network}
                      onChange={handleChange("access_network")}
                      placeholder="Select Network"
                    />
                  ),
                  gridSize: 4,
                },
              ],
            },
          ]
          : []),
        ...(formData?.type === "LAN" && formData?.linkType == 'LAN Trunk'
          ? [
            {
              columns: [
                {
                  component: (
                    <MultipleSelectChip
                      defaultSelection={formData?.access_networks || []}
                      handleSelection={handleChange("access_networks")}
                      // Use networks from formData when editing, otherwise fallback to lanNetworks
                      values={(formData?.networks?.map(n => n.network_alias)) || (lanNetworks?.map(n => n.network_alias)) || []}
                      name={'Access Network(s)'}
                      sx={{ maxWidth: "100%", width: "100%", maxHeight: "200px" }}
                      disabled={isVersionLessThanEqual(selectedRow['current_EOS_version'], 'v1.1.0.754')}
                      maxHeight={"auto"}
                      maxSelections={0}
                    />
                  ),
                  gridSize: 12,
                },
              ],
            },
          ]
          : []),
        ...(formData?.type === "WIFI"
          ? [
            {
              columns: [
                {
                  component: (
                    <LabelValueDisplay
                      label="WI-FI Band"
                      isDropdown
                      value={formData?.device}
                      dropdownOptions={formData?.mode == 'Access Point' ? ["WIFI_ALL","WIFI_2.4","WIFI_5"] : ["WIFI_2.4","WIFI_5"]}
                      onChange={handleChange("device")}
                      placeholder="Select Band"
                      disabled={isEditPopup && !isWifiBandEditable}
                      infoText={isEditPopup && isWifiBandEditable ? "Changing band will interrupt internet traffic." : ""}
                    />
                  ),
                  gridSize: 6,
                },
                {
                  component: (
                    <LabelValueDisplay
                      label="LAN Network"
                      isDropdown
                      dropdownOptions={lanNetworks?.map(network => network.network_alias)}
                      value={formData?.network}
                      onChange={handleChange("network")}
                      placeholder="Select Network"
                      disabled={isEditPopup || formData?.mode !== "Access Point"}
                    />
                  ),
                  gridSize: 6,
                },
              ],
            },
            {
              columns: [
                {
                  component: (
                    <Box height="21px" />
                  ),
                  gridSize: 12,
                }
              ]
            },
            {
              columns: [
                {
                  component: (
                    <LabelValueDisplay
                      label="Security"
                      isDropdown
                      value={formData?.security}
                      dropdownOptions={["WPA2/WPA3", "Open"]}
                      onChange={handleChange("security")}
                      placeholder="Select Security"
                      disabled={formData?.forceSecurityOpen}
                    />

                  ),
                  gridSize: 6,
                },
                {
                  component: (
                    <LabelValueDisplay
                      label="Password"
                      isInput
                      value={formData?.password}
                      onChange={handleChange("password")}
                      placeholder="Enter Password"
                      isPassword={true}
                      passwordClass={true}
                      boxWidth={183}
                      disabled={formData?.security != 'WPA2/WPA3'}
                      error={passwordError}
                      infoText={formData?.security == 'WPA2/WPA3' ? 'Password must be at least 8 characters.' : ''}
                    />
                  ),
                  gridSize: 6,
                },
              ],
            },
          ]
          : []),
        ...(formData?.type === "WIFI" && formData?.mode === "WAN WI-FI" && isHubSupported
          ? [
            {
              columns: [
                {
                  component: (
                    <ToggleWithLabel
                      label="Hub Dropoff"
                      checked={!!formData?.hub_enabled}
                      onChange={(val) => setFormData((prev) => ({ ...prev, hub_enabled: val }))}
                    />
                  ),
                  gridSize: 12,
                },
              ],
            },
          ]
          : []),
        {
          columns: [
            {
              component: (
                <Box height="21px" />
              ),
              gridSize: 12,
            }
          ]
        },

        {
          columns: [
            {
              component: (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {!_.isEmpty(updateWanInterface) && updateWanInterface.msg}
                </span>
              ),
              gridSize: 12,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {!_.isEmpty(addWanInterface) && addWanInterface.msg}
                </span>
              ),
              gridSize: 12,
            },
          ],
        },
      ]}
    />
    {row.alias && (
      <DeleteWANProfileModal
        open={isDeleteModalOpen}
        onClose={() => {
          setIsDeleteModalOpen(false);
          row['interface_type'] === 'WAN' && dispatch({ type: DELETE_INTERFACE, payload: {} });
          row['interface_type'] === 'WIFI' && dispatch({ type: DELETE_WIFI, payload: {} });
        }}
        onConfirm={() => {
          interfacesAutoRefresh.startAction();
          notifyConfigAction?.();
          switch (row['interface_type']) {
            case 'WAN':
              deleteInterfaceData(selectedRow['deviceId'], row['id']);
              break;
            case 'LAN':
              deleteLanData(selectedRow['deviceId'], row['vlanId'], row['id']);
              break;
            case 'WIFI':
              deleteWifiData(selectedRow['deviceId'], row['id']);
              break;
          }
        }}
        profileName={row['interface_type'] === "WIFI" ? row['ssid'] : row['alias']}
        errorMessage={
          row['interface_type'] === 'WAN' && deleteInterface?.status === false ? deleteInterface.msg :
          row['interface_type'] === 'WIFI' && deleteWifi?.status === false ? deleteWifi.msg : ''
        }
      />
    )}
    <DeleteWANProfileModal
      open={!!hubTogglePendingRow}
      onClose={() => setHubTogglePendingRow(null)}
      onConfirm={handleHubToggleConfirm}
      title="Hub Dropoff"
      titleWithDeleteIcon={false}
      confirmText="Confirm"
      cancelText="Cancel"
      warningMessage=""
      entityLabel={hubTogglePendingRow?.hub_enabled
        ? `Confirm Disabling of Hub Dropoff for "${hubTogglePendingRow?.alias}"`
        : `Confirm Enabling of Hub Dropoff for "${hubTogglePendingRow?.alias}"`
      }
      entityName={undefined}
    />
  </div>
  );
};

const mapStateToProps = (state) => ({
  getAllInterfaces: state.authReducer.getAllInterfaces,
  deleteInterface: state.authReducer.deleteInterface,
  deleteLan: state.authReducer.deleteLan,
  deleteWifi: state.authReducer.deleteWifi,
  addWanInterface: state.authReducer.addWanInterface,
  updateWanInterface: state.authReducer.updateWanInterface,
  getPhysicalInterfaces: state.authReducer.getPhysicalInterfaces,
  enableDisableInterface: state.authReducer.enableDisableInterface,
  getFilteredNetworks: state.authReducer.getFilteredNetworks,
  getAllInterfacesLoading: state.authReducer.getAllInterfacesLoading,
  getPhysicalInterfacesLoading: state.authReducer.getPhysicalInterfacesLoading,
  getFilteredNetworksLoading: state.authReducer.getFilteredNetworksLoading,
  addWanInterfaceLoading: state.authReducer.addWanInterfaceLoading,
  updateWanInterfaceLoading: state.authReducer.updateWanInterfaceLoading,
  deleteInterfaceLoading: state.authReducer.deleteInterfaceLoading,
  enableDisableInterfaceLoading: state.authReducer.enableDisableInterfaceLoading,
  getDeviceLinkStatus: state.authReducer.getDeviceLinkStatus,
  lANTrunkFilteredNetworks: state.authReducer.getLANTrunkFilteredNetworks,
  deviceLinkStatusLoading: state.authReducer.getDeviceLinkStatusLoading,
});

export default withRouter(
  connect(mapStateToProps, { getAllInterfacesData, deleteInterfaceData, getPhysicalInterfacesData, addWanInterfaceData, updateWanInterfaceData, enableDisableInterfaceData, getFilteredNetworksData, deleteLanData, deleteWifiData, getDeviceLinkStatusData, getFilteredLanTrunkNetworksData })(InterfacesTab)
)